import { Component, ViewChild } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SpecialsdashboardPage } from "../specialsdashboard/specialsdashboard";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { AngularFireDatabase } from 'angularfire2/database';


@Component({
  selector: 'page-specials',
  templateUrl: 'specials.html',
})
export class SpecialsPage {
  @ViewChild('listAnimate') lstAnimate;
  public allRecipes: any = [];
  public loadedRecipeList: Array<any>;
  public loading: boolean = true;
  public path: string = '';

  defaultImage: string = 'assets/icon/placeholder.png';
  _items: any;
  constructor(public navCtrl: NavController,
    public animationService: SmartanimationProvider,
    public af: AngularFireDatabase
  ) {

    console.log('init');
    this.loading = true;
    //  let user = JSON.parse(localStorage.getItem('UserId'));



  }
  ngOnInit() {
    let userObj = JSON.parse(localStorage.getItem('UserObj'));
    let userId = JSON.parse(localStorage.getItem('UserId'));
    console.log(userObj);

    this.path = userObj.waiterTo != "-1" ? 'specials/' + userObj.clientId : 'restaurants/-1/servers/' + userId.uid + '/specials';

    this.af.list(this.path).snapshotChanges().map(t => {
      return t.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    })
      .subscribe(t => {
        this._items = t;
        this.allRecipes = t;
        this.loadedRecipeList = t;
        this.loading = false;
      })
  }

  ionViewWillEnter() {
    this.animationService.smartAnimation().setType('fadeIn').show(this.lstAnimate.nativeElement);
  }

  initializeItems(): void {
    this.allRecipes = this.loadedRecipeList;
  }

  filterSpecials(ev: any) {
    this._items = this.allRecipes;
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this._items = this._items.filter((item) => {
        return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  getItems(searchbar) {
    // Reset items back to all of the items
    console.log('search item');
    this.initializeItems();
    // set q to the value of the searchbar
    let q = searchbar.srcElement.value;
    // if the value is an empty string don't filter the items
    if (!q) {
      return;
    }
    this.allRecipes = this.allRecipes.filter((v) => {
      if (v.title && q) {
        if (v.title.toLowerCase().indexOf(q.toLowerCase()) > -1) {
          return true;
        }
        return false;
      }
    });
  }

  goToEditSpecial(special: any) {
    this.navCtrl.push(SpecialsdashboardPage, { specialItem: special , path: this.path })
  }

  addItem() {
    this.navCtrl.push(SpecialsdashboardPage, { path: this.path });
  }
}



// WEBPACK FOOTER //
// ./src/pages/specials/specials.ts